import React, { useContext, useEffect, useState } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import DataContext from '../data/DataContext';
import InputContext from '../data/InputContext';
import Arrow from '../../asset/img/ic_list_arrow_nor.svg';
import Up from '../../asset/img/arr_d_3.svg';
import { useToasts } from 'react-toast-notifications';

const hangul = require('hangul-js');

const styles = (theme) => ({
  root: {
    width: '100%',
    // maxHeight: '7rem',
    height: '100%',
    // overflowY: 'auto',
    // border: `1px solid ${theme.color.list_divider}`,
    background: '#f5f5f5',
    backgroundColor: '#ffffff',
    transition: 'all .3s ease-in-out',
    zIndex: 12,
    // borderRadius: "20px 20px 0px 0px",
  },
  autoCompleteContainer: {
    maxHeight: '50%',
    position: 'fixed',
    left: '0',
    bottom: '54px',
    width: '100%',
    zIndex: '10',
    overflowY: 'auto',
  },
  up: {
    border: `1px solid ${theme.color.list_divider}`,
    borderRadius: '10px 10px 0px 0px',
    borderBottom: '0px',
    backgroundColor: '#ffffff',
    width: '100%',
    height: '20px',
    '&:active': {
      backgroundColor: theme.color.list_divider,
    },
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    textIndent: '-99999rem',
  },
  upIcon: {
    backgroundImage: `url(${Up})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '15px',
    borderRadius: '20px',
    width: '100px',
    height: '20px',
    // outline: "none",
    '-moz-transform': 'scaleY(1)',
    '-o-transform': 'scaleY(1)',
    '-webkit-transform': 'scaleY(1)',
    transform: 'scaleY(1)',
  },
  upReverse: {
    '-moz-transform': 'scaleY(-1)',
    '-o-transform': 'scaleY(-1)',
    '-webkit-transform': 'scaleY(-1)',
    transform: 'scaleY(-1)',
  },
  close: {
    maxHeight: '0px',
    borderTop: '0px solid #ccc',
  },
  item: {
    width: '100%',
    minHeight: '40px',
    background: '#ffffff',
    textTransform: 'none',
    padding: '14px 24px',
    // outline: "0 none",
    border: 'none',
    display: 'flex',
    justfyContent: 'between-space',
    alignItems: 'center',
    // font: "-apple-system-body",
  },
  category: {
    borderRadius: '20px',
    fontSize: theme.font.size12, //"12px",
    fontWeight: 'bold',
    color: '#e84472',
    border: '2px solid #e84472',
    width: '85px',
    height: '25px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    font: '-apple-system-body',
  },
  text: {
    flex: 1,
    textAlign: 'start',
    // textOverflow: "ellipsis",
    // overflow: "hidden",
    // whiteSpace: "nowrap",
    wordBreak: 'break-word',
    fontSize: theme.font.size14, // "15px",
    fontWeight: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',

    color: theme.color.text_color.black,
  },
  arrow: {
    width: '24px',
    height: '24px',
    backgroundSize: '24px',
    backgroundImage: `url(${Arrow}) no-repeat right center`,
  },
  divider: {
    background: theme.color.list_divider,
    height: '1px',
    width: '100%',
  },
  hidden: {
    width: '0px',
    height: '0px',
    margin: '0px',
    fontSize: '0.1px',
    textIndent: '-9999px',
  },
});

function AutoComplete(props) {
  var { classes } = props;
  const data = useContext(DataContext);
  const input = useContext(InputContext);
  const [maxHeight, setMaxHeight] = useState('7rem');
  const [buttonUpReverse, setButtonUpReverse] = useState(false);
  const [buttonUpReverseTitle, setButtonUpReverseTitle] = useState('축소됨');

  const deleteAllBTag = (inputObj) => {
    let replacedObj = Object.keys(inputObj).reduce((newObj, curValue, curIndex) => {
      newObj[curValue] = inputObj[curValue].replace(/<b>/gi, '').replace(/<\/b>/gi, '');
      return newObj;
    }, {});
    return replacedObj;
  };

  const handleClick = (item) => {
    console.log('handleAutoCompleteClose', item);
    input.autoComplete.setEnable(false);
    if (item.speech && item.speech !== '') {
      let selectedData = item.speech;
      if (item.filter === 'content' || item.filter === 'symptom') {
        selectedData = selectedData.replace(/<b>/gi, '').replace(/<\/b>/gi, '');
        if (item.useSpeech) {
          data.request(data, selectedData, 'button');
        } else {
          let replacedObj = deleteAllBTag(item.orgData);
          data.request(data, selectedData, 'button', replacedObj, {
            mode: 'bypass',
            intent: 'AUTO_COMP_CONTENTS',
          });
        }
      } else {
        data.request(data, selectedData, 'button');
      }

      input.setInput('');
    }
  };

  const handleUp = () => {
    if (maxHeight === '7rem') {
      setMaxHeight('calc(100% - 370px)');
      setButtonUpReverse(true);
      setButtonUpReverseTitle('확장됨');
    } else {
      setMaxHeight('7rem');
      setButtonUpReverse(false);
      setButtonUpReverseTitle('축소됨');
    }
  };

  const sortedList =
    input.autoComplete.parameters &&
    input.autoComplete.parameters.items &&
    input.autoComplete.parameters.items.sort((prev, curr) => {
      return parseInt(prev.order) < parseInt(curr.order)
        ? -1
        : parseInt(prev.order) > parseInt(curr.order)
        ? 1
        : 0;
    });

  // var filteredList =
  //   sortedList &&
  //   sortedList.filter((item) => {
  //     const result = hangul.search(
  //       item.data?.toLowerCase(),
  //       input.input.trimLeft().toLowerCase()
  //     );
  //     return result >= 0;
  //   });
  var filteredList = sortedList;

  if (input.input === '' && sortedList) {
    filteredList = sortedList;
  }

  useEffect(() => {
    if (!input.autoComplete.open) {
      setMaxHeight('7rem');
    }
  }, [input.autoComplete.open]);

  return input.autoComplete.enable &&
    input.autoComplete.open &&
    input.autoComplete.parameters &&
    input.autoComplete.parameters.items &&
    input.autoComplete.parameters.items.length > 0 ? (
    <div
      id="autoCompleteContainer"
      className={classes.autoCompleteContainer}
      style={{ maxHeight: maxHeight }}
    >
      <p className={classes.hidden} role={'status'}>
        입력 예시 표시됨.
      </p>
      <button
        className={classes.up}
        onClick={handleUp}
        aria-expanded={buttonUpReverse}
        title={buttonUpReverseTitle}
      >
        자동완성 더보기
        <div
          className={[
            classes.upIcon,
            maxHeight === '7rem' ? classes.upReverse : null,
          ].join(' ')}
        />
      </button>
      <div
        className={[
          classes.root,
          input.autoComplete.enable && input.autoComplete.open ? '' : classes.close,
        ].join(' ')}
        onTouchMove={(e) => e.stopPropagation()}
        // style={{ maxHeight: maxHeight }}
      >
        {input.autoComplete.enable &&
          input.autoComplete.open &&
          input.autoComplete.parameters &&
          input.autoComplete.parameters.items &&
          filteredList &&
          filteredList.map((item, index) => {
            if (index >= 30) return null;

            let combine = item.data;
            let ariaLabelText = item.data.replace(/<b>/gi, '').replace(/<\/b>/gi, '');

            let spanStart = `<span style="color: #ea1917; font-weight: bold; font-family: Noto Sans CJK KR, Noto Sans, RobotoDraft, Roboto, San Francisco, Apple SD Gothic Neo, Helvetica Neue, sans-serif; line-height: 1.43; letter-spacing: normal; font-size: 0.875rem;">`;
            let categorySpanStart = `<span style="color: #666; font-weight: normal; font-family: Noto Sans CJK KR, Noto Sans, RobotoDraft, Roboto, San Francisco, Apple SD Gothic Neo, Helvetica Neue, sans-serif; line-height: 1.43; letter-spacing: normal; font-size: 0.875rem;">`;
            let spanEnd = `</span>`;
            if (item.filter === 'content' || item.filter === 'symptom') {
              combine = combine.replace(/<b>/gi, spanStart).replace(/<\/b>/gi, spanEnd);
              item.category = item.category.replace(/<b>/gi, '').replace(/<\/b>/gi, '');
              // item.data = item.data.replace(/<b>/gi,"").replace(/<\/b>/gi,"");
            } else if (input.input && input.input.length > 0) {
              const result = hangul.search(
                item.data?.toLowerCase(),
                input.input.trimLeft().toLowerCase()
              );
              if (result >= 0) {
                const arrData = item.data.toLowerCase().split(input.input.toLowerCase());
                const first = item.data.substring(0, arrData[0].length);
                const find = item.data.substring(
                  arrData[0].length,
                  arrData[0].length + input.input.length
                );
                const last = item.data.substring(
                  arrData[0].length + input.input.length,
                  item.data.length
                );
                combine = [first, last].join(`${spanStart}${find}${spanEnd}`);
              } else {
                combine = '';
              }
            }

            if (combine) {
              combine = `${categorySpanStart}${
                item.category
              }${'\u00A0\u00A0'}|${'\u00A0\u00A0'}${spanEnd}${combine}`;
            }

            return (
              combine && (
                <>
                  <Grid container>
                    <Grid item xs={12}>
                      <button
                        type="button"
                        className={classes.item}
                        onClick={() => handleClick(item)}
                        key={index}
                        title={`${ariaLabelText}, ${index + 1} / ${filteredList.length}`}
                      >
                        <div
                          className={classes.text}
                          dangerouslySetInnerHTML={{
                            __html: combine,
                          }}
                        />
                        {/* <div className={classes.arrow} /> */}
                      </button>
                    </Grid>
                  </Grid>
                  {(filteredList.length < 30
                    ? index !== filteredList.length - 1
                    : index < 29) && <div className={classes.divider} />}
                </>
              )
            );
          })}
      </div>
    </div>
  ) : null;
}
export default withStyles(styles)(AutoComplete);
